import {Component, OnInit, Input, Output, EventEmitter, OnChanges, OnDestroy, SimpleChanges} from '@angular/core';
import {Subscription} from 'rxjs';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../../services/auth.service";

@Component({
  selector: 'micro-site-picklist',
  templateUrl: './site-picklist.component.html'
})
export class SitePicklistComponent implements OnChanges, OnDestroy {
  private request?: Subscription;
  all:any[];
  description:any;

  @Input()
  companyId;

  @Output()
  selectedItemsChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  selectedItems:string[];

  onNgModelChange(e) {
    this.selectedItemsChange.emit(e);
  }

  constructor(private auth:AuthService, private env:EnvService, private http:HttpClient) {
  }

  reload() {
    this.request?.unsubscribe();
    this.all = [];
    if (!this.companyId) return;
    let params = new HttpParams().set('cId', this.companyId);
    return this.request = this.http.get(`${this.env.e.url}/domain/sites/all`, {params})
      .subscribe({next: data => this.all = data as any[], error: () => this.all = []});
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.companyId) {
      this.reload();
    }
  }

  ngOnDestroy(): void {
    this.request?.unsubscribe();
  }
}
